import { Box, Divider, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";

export default function RMDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const firstName = overviewData.rm?.user.firstName;
    const phone = overviewData.rm?.user?.phone;
    const email = overviewData?.rm?.user?.email;
    const countryCode = overviewData?.rm?.user?.countryCode

    const taggedRmFirstName = overviewData?.taggedRm?.user?.firstName;
    const taggedRmPhone = overviewData?.taggedRm?.user?.phone;
    const taggedRmEmail = overviewData?.taggedRm?.user?.email;
    const taggedRmCountryCode = overviewData?.taggedRm?.user?.countryCode

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography  variant="h2" sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                RM Details
                            </Typography>

                        </Grid>
                        <Grid
                            item
                            container
                            rowSpacing={3}
                            columnSpacing={5.5}
                            direction="row"

                        >
                            <KeyValue title={"RM's Name"} description={firstName} />
                            <KeyValue title={"RM's Email Address"} description={email} />
                            <KeyValue title={"RM's Mobile Number"} description={`${countryCode} ${phone ?? "-"}`} />

                        </Grid>

                    </Grid>

                    <Box my={4}>
                        <Divider />
                    </Box>

                    {/* Tagged RM Info Start */}
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography  variant="h2" sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                Tagged RM Details
                            </Typography>

                        </Grid>
                        <Grid
                            item
                            container
                            rowSpacing={3}
                            columnSpacing={5.5}
                            direction="row"

                        >
                            <KeyValue title={"Tagged RM's Name"} description={taggedRmFirstName ?? ""} />
                            <KeyValue title={"Tagged RM's Email Address"} description={taggedRmEmail} />
                            <KeyValue title={"Tagged RM's Mobile Number"} description={`${taggedRmCountryCode ?? ""} ${taggedRmPhone ?? "-"}`} />
                        </Grid>
                    </Grid>
                    {/* Tagged RM Info End */}
                </Box>
            </Box >
        </>
    )
}